import { chain } from 'lodash';

export const toQueryString = obj => chain(obj)
	.keys()
	.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
	.join('&')
	.value();



// WEBPACK FOOTER //
// ./src/util/index.js